import { Component, AfterViewInit, OnDestroy, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import 'tinymce/tinymce.min'; //import tinymce.min instead of tinymce to enable build-optimizer
import 'tinymce/icons/default'; // Load tinyMCE format option icons
import * as Rx from "rxjs";
import { AppUtils } from '../../../common/utility/appUtil';
import { UserDataService } from '../../../services/user-data.service';
import { QmaConstant } from '../../../constant/qma-constant';
import { ElementRef } from "@angular/core";
import { Renderer2 } from "@angular/core";
import { NewMessageService } from '../../../services/newMessage/new-message.service';
declare var tinymce: any;
import $ from 'jquery';
import { TabDataService } from '../../../services/tab-data.service';
import { environment } from 'src/environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthModeService } from '../../../auth/auth-mode.service';

@Component({
  selector: 'editor-app',
  styleUrls: ['./exp-tiny.component.css'],
  template: `<textarea  autofocus={{true}} [autofocus]="true" id="{{elementId}}" style="height:{{height}}px;" placeholder="{{placeholderText}}" *ngIf="loadEditor"   ></textarea>`
})


export class ExpTinyComponent implements AfterViewInit, OnDestroy {
  @Output() editorDrag = new EventEmitter<any>();
  @Input() toolbarOptions: number = 0;
  @Input() elementId: String;
  @Input() template: any;
  @Input() height: any = 200;
  @Input() skip_focus: boolean = false; //skip_focus arg for displaying placeholder text
  @Input() fromNewMessage: boolean = false;
  @Input() horizontalStyle: boolean = false;
  @Input() fromAdminAutoResponse: boolean = false;
  @Input() content: string='';
  horizontalView: boolean = false;
  @Output() onLoad: EventEmitter<any> = new EventEmitter<any>();
  @Input() disabled: boolean = false; // true for disabling editor
  @Input() fromComponent?: string = 'group-admin';
  @Output() inlineImage = new EventEmitter();
  @Output() keyupChange = new EventEmitter();
  @Output() keyupChangeSymphony = new EventEmitter();
  @Output() onBlur = new EventEmitter<void>();  // Event emitter for blur
  @Output() filePasted = new EventEmitter<File[]>();
  @Output() change = new EventEmitter<any>();
  fontStyle: any;
  fontSizeList;
  fontStyleList = "";
  isMobile: boolean = false;

  TINYMCE_URL: string;
  PLACEHOLDER_ID: string = 'qmatinymceplaceholder';
  editor;
  id: String;
  toolBarShow: String = "";
  toolBarLocation: String = "";

  LoadFlag = new Rx.BehaviorSubject(false);
  @Output() sendEvent = new EventEmitter();
  messageInstance; // current message instance

  //TODO:Performance :: Calculate the time.
  startTime: any;

  isDefaultFontApplied = false;
  forPdfViewerReInitialise = false;
  loadEditor = true;
  contentBeforeEditorReload = "";
  originalContentFromNlpSuggestion: any;
  contentEdited: string = 'Not Edited';

  @Input() placeholderText: string = "Type here";
  isPlaceholderVisible: boolean = false;

    // For the global interceptor
  private originalXhrOpen: any;
  private originalXhrSend: any;

  private viewClickedSubscription: Rx.Subscription;
  constructor(private userDataService: UserDataService, private element: ElementRef, private renderer: Renderer2, private newMessageService: NewMessageService, private tabService: TabDataService, private oauthService: OAuthService, private authModeService: AuthModeService) {
    //TODO:Performance :: Start Time.
    this.startTime = performance.now();

     // this.TINYMCE_URL = this.userDataService.getTinyMceUrl(); // QMA-1951: We will be using the base URL for spellchecker from now on for validating the access_token. Preserving this for reference.
    this.TINYMCE_URL = QmaConstant.AUTH_URL;
    this.fontStyle = this.userDataService.getDefaultFontDetail();
    this.userDataService.getEditorFontStyle().map((val) => {
      this.fontStyleList += val + "=" + val + ";";
    });
    this.fontSizeList = this.userDataService.getEditorFontSize().join(" ");

    if (window.innerWidth <= QmaConstant.MOBILE_WIDTH) {
      this.isMobile = true;
    }
    else {
      this.isMobile = false;
    }
  }
  // Function to detect blur event (when the editor loses focus)
  private setupBlurEvent(editor) {
    editor.on('blur', () => {
      this.onBlur.emit();  // Emit the blur event
    });
  }

  isToolBarOption(options: number) {
    switch (options) {
      case 1:
        //for other small areas like template and signature
       this.toolBarShow = 'fontfamily fontsize | bold italic underline alignleft aligncenter alignright casechange spellchecker';
        break;
      case 2:
        //for Profile setting - template, signature and out of office
        this.toolBarShow = 'fontfamily fontsize | bold italic underline strikethrough | alignleft aligncenter alignright justifyfull | link | ' +
          'bullist numlist outdent indent | anchor | undo redo | forecolor backcolor | fontselect | fontsizeselect |  removeformat  formatpainter  powerpaste  table casechange spellchecker';
        break;
      case 3:
        //for Mobile
        // this.toolBarLocation  = 'bottom'
        break;
        // default:
        //   this.toolBarShow = 'bold italic underline strikethrough | alignleft aligncenter alignright justifyfull | link | ' +
        //     'bullist numlist outdent indent | anchor | print | undo redo | forecolor backcolor | fontselect fontsizeselect |  removeformat  formatpainter  powerpaste  table casechange';
      default:
        if(this.fromNewMessage || this.horizontalView || this.fromAdminAutoResponse){
                  this.toolBarShow = 'fontfamily fontsize | bold italic underline strikethrough | alignleft aligncenter alignright justifyfull | link | ' +
          'bullist numlist outdent indent | anchor | print | undo redo | forecolor backcolor | formatpainter  powerpaste   casechange spellchecker | | customCloseButton'
        }
        else{
          this.toolBarShow = 'fontfamily fontsize | bold italic underline | aligncenter | bullist | link |print | alignment spellchecker | | customCloseButton'
        }

    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if ('disabled' in changes && tinymce.get(this.elementId)) {
      if (changes['disabled']) {
        this.disabled = changes['disabled']?.currentValue;
      }
      this.updateEditorMode();
    }
    if ('content' in changes && tinymce.get(this.elementId)) {
      tinymce.get('autoResponse')?.setContent(this.content);
    }
  }
  private updateEditorMode() {
    const editor = tinymce.get(this.elementId);
    if (editor) {
      editor.mode.set(this.disabled ? 'readonly' : 'design'); // Update editor mode dynamically
    }
  }
  ngAfterViewInit() {
    // Global Interceptor
    // Save the original functions to restore them later
    this.originalXhrOpen = XMLHttpRequest.prototype.open;
    this.originalXhrSend = XMLHttpRequest.prototype.send;
    // Capture the component's 'this' context for use inside the patch
    const componentThis = this;
    // Patch the 'open' method to store the URL
    XMLHttpRequest.prototype.open = function(method: string, url: string | URL, ...args: any[]) {
      // Store the URL on the XHR object itself for the 'send' patch to read
      this._url = url; 
      return componentThis.originalXhrOpen.apply(this, [method, url, ...args]);
    };
    // Patch the 'send' method to add the header
    XMLHttpRequest.prototype.send = function(...args: any[]) {
      const requestUrl = this._url;
      // Check the stored URL against our spellchecker URL
      if (requestUrl?.startsWith(componentThis.TINYMCE_URL)) {
        // QMA-1951: GLOBAL INTERCEPTOR CAUGHT THE REQUEST! Adding headers
        // Mirror http-interceptor.ts: use IdP access token in IdP mode, symphony_jwt in COT mode.
        let token: string | null = null;
        if (componentThis.authModeService.isIdp()) {
          token = componentThis.oauthService.getAccessToken() || null;
        } else {
          token = sessionStorage.getItem('symphony_jwt');
        }
        if (token) {
          this.setRequestHeader('Authorization', 'Bearer ' + token);
        }
        // Origin context for TinyMCE Auth service calls should be the auth service context.
        this.setRequestHeader('originContext', QmaConstant.AUTH_URL);
      }
      return componentThis.originalXhrSend.apply(this, args);
    };
    // this.updateEditorByPdfViewer();
    setTimeout(() => {
      let readOnly;
      if (this.fromComponent !== 'group-admin') {
        readOnly = true;
      }
      else {
        readOnly = this.disabled ? 1 : 0;
      }
      if (this.isMobile) {
        this.isToolBarOption(3); //For Mobile options
      }
      else {
        this.isToolBarOption(this.toolbarOptions);
      }

      const tinyMceAssetsBaseUrl = '/assets/tinymce';
      tinymce.baseURL = tinyMceAssetsBaseUrl;
      tinymce.init({
        selector: '#' + this.elementId,
        base_url: tinyMceAssetsBaseUrl,
        license_key: environment.TINY_MCE_LICENSE_KEY,
		    paste_as_text: false,  // Allow HTML but prevent force text mode to avoid extra row during paste
        paste_auto_cleanup_on_paste: false,  // Prevent TinyMCE from modifying pasted content
        paste_webkit_styles: "none",  // Prevent WebKit style processing, no extra style added during paste
        valid_children: "+body[style],+div[style],+table[style]", // Preserve styling
        extended_valid_elements: '+div[*] table[style],tr[style],td[style],th[style],span[style]',
        // Add any unwanted symbol in the protect array, the tinymce editor will not consider it as text.
        // POC: http://fiddle.tinymce.com/pAfaab/6
        // https://stackoverflow.com/questions/40234340/stripping-out-if-mso-by-displaying-in-tinymce
        // https://www.tiny.cloud/docs/configure/content-filtering/#protect
        // Arbitrary junk values are populating on message body
        protect: [
          /\<!\[if !mso\]\>/g,             // Protect <![if !mso]>
          /\<!\-\-\[if gte mso 10\]\>/g,   // Protect <!--[if gte mso 10]>
          /\<!\[if !vml\]\>/g,             // Protect <![if !vml]>
          /\<!\[endif\]\>/g,               // Protect <![endif]>
          /<\?php[\s\S]*?\?>/g             // Protect <?php ?> code
        ],
        mobile: {
          theme: 'silver'
        },
        readonly: readOnly,
        height: this.height,
        width: "100%",        
        plugins: 'code autolink link image  lists table formatpainter powerpaste casechange tinymcespellchecker',
        spellchecker_rpc_url: this.TINYMCE_URL,
        spellchecker_language: 'en_US',
        spellchecker_active: true,
        contextmenu_never_use_native: true, // Prevents the browser's context menu
        contextmenu: "spellchecker | cut copy custompaste",
        // Update the tinyMCE url
        external_plugins: {         
          'formatpainter': `${tinyMceAssetsBaseUrl}/plugins/formatpainter/plugin.js`,
          'powerpaste': `${tinyMceAssetsBaseUrl}/plugins/powerpaste/plugin.js`,
          'casechange': `${tinyMceAssetsBaseUrl}/plugins/casechange/plugin.js`,
          'tinymcespellchecker': `${tinyMceAssetsBaseUrl}/plugins/tinymcespellchecker/plugin.js`
        },
        //formatting button added
        formats: {
          formatpainter_removeformat: [
            {
              selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins',
              remove: 'all', split: true, expand: false, block_expand: true, deep: true
            },
            { selector: 'span', attributes: ['style', 'class'], remove: 'empty', split: true, expand: false, deep: true },
            { selector: '*:not(tr,td,th,table)', attributes: ['style', 'class'], split: false, expand: false, deep: true }
          ]
        },
        powerpaste_block_drop: true,
        paste_postprocess: (editor, fragment) => {
          //fragment.node.appendChild(textnode);
          let element = fragment.node.innerHTML;

          let inlineImagePresent = false;

          if (!AppUtils.isUndefinedOrNull(element)) {
            let text = element;
            if (!AppUtils.isUndefinedOrNull(text) && text.toString().indexOf('<img src="blob:') !== -1) {
              inlineImagePresent = true;
            }
          }
          this.inlineImage.emit(inlineImagePresent);
        },
        fontsize_formats: this.fontSizeList,
        font_formats: this.fontStyleList,
        toolbar: this.toolBarShow,
        // toolbar_location : this.toolBarLocation,
        menubar: false,
        browser_spellcheck: false,
        powerpaste_html_import: true,
        cleanup: true,
        //additional space in outlook
        force_br_newlines: true,

        forced_root_block: 'p', //Spacing Issue.
        forced_root_block_attrs: {
          //Navigation : Additional user level preference option
          // to set font from profile settings
          // 'style': 'margin: 0px 0px;' + `font-family:${this.fontStyle.fontName};` // + `font-size:${this.fontStyle.fontSize}`
        },
        // remove_linebreaks: true,
        //convert_newlines_to_brs: true,
        // inline_styles: false,
        // entity_encoding: 'name',
        // entities: '160,38,amp,nbsp,60,lt,62,gt',
        // entity_encoding: 'raw', // performace refactor change
        // verify_html : false, // performace refactor change
        statusbar: false,

        init_instance_callback: (editor) => {
          this.setupBlurEvent(editor);

          this.enableFlag();
          if (!this.forPdfViewerReInitialise) {
            this.onLoad.emit("Loaded");
          } else {
            // reset flag
            this.forPdfViewerReInitialise = false;
            this.setData(this.contentBeforeEditorReload);
            this.contentBeforeEditorReload = "";
          }

          this.fontSet(this.skip_focus); //pass in skip_focus arg
        }, // Listen to TinyMce changes

        content_style: `
          .mce-placeholder {
            color: #7E819B !important;
            font-family: OpenSans !important;
            font-size: 14px !important;
            position: relative;
            opacity: 1 !important;
          }
          /* Show placeholder only when first p before signature is empty */
          #tinymce:has(#signatureDiv) > p:first-child:not([data-content])::before {
            content: 'Type here';
            color: #7E819B;
            font-family: OpenSans, sans-serif;
            font-size: 14px;
            pointer-events: none;
            position: absolute;
          }
          body.mce-content-body[data-mce-placeholder].mce-placeholder:not(.mce-visualblocks)::before {
            color: #7E819B !important;
            opacity: 1 !important;
          }
        `,
        setup: (e) => {
          const filePastedTemp = this.filePasted;
          const readClipboard = async () => {
            try {
              const permission = await navigator.permissions.query({ name: "clipboard-read" as any });

              if (permission.state === "granted" || permission.state === "prompt") {
                try {
                  const text = await navigator.clipboard.readText();
                  return text;
                } catch (err) {
                  console.error("Failed to read clipboard contents: ", err);
                  alert("Clipboard access is required to paste content.");
                  return null;
                }
              } else {
                console.warn("Clipboard access denied!");
                alert("Clipboard access is required to paste content.");
                return null;
              }
            } catch (error) {
              console.error("Failed to read clipboard contents: ", error);
              alert("Failed to request clipboard permission.");
              return null;
            }
          };
            // Add custom CSS after editor initialization
            // e.on('init', () => {
            //     const style = document.createElement('style');
            //     style.innerHTML = `
            //         .tox-toolbar__group:last-child {
            //             margin-left: auto !important;
            //         }
            //         .tox .tox-toolbar__group:last-child {
            //             float: right;
            //         }`;
            //     e.getContainer().appendChild(style);
            //     // Show placeholder if content is empty
            //     if (e.getContent({format: 'text'}).trim() === '') {
            //       e.setContent(`<span class="mce-placeholder">${this.placeholderText}</span>`);
            //       this.isPlaceholderVisible = true;
            //     }
            // });
            e.ui.registry.addMenuItem('custompaste', {
              text: 'Paste',
              icon: 'paste',
              onAction: function() {
                console.log('custompaste')
              }
            });
            e.on('dragstart dragenter dragover', (e: any) => {
              this.editorDrag?.emit(e);
            });
            e.ui.registry.addContextMenu('custompaste', {
              update: function(element) {
                return [
                  {
                    text: 'Paste',
                    icon: 'paste',
                    onAction: async () => {  // Arrow function preserves "this"
                      let text = await readClipboard();  // Ensure readClipboard() is in your component
                      const storedFile = sessionStorage.getItem('pastedFile');
                      if (storedFile) {
                        const fileData = JSON.parse(storedFile);
                        filePastedTemp.emit(fileData);  // Use the passed-in EventEmitter
                      } else {
                        e.insertContent(text);
                      }
                    }
                  }
                ];
              }
            });
            e.on('paste', (e) => {
              this.handlePaste(e);
            });


            e.on('keydown', (event) => {
                this.fontSet(this.skip_focus);
                this.change.emit();
            }),
            e.on('keyup', (event) => {
              const body = e.getBody();
              const signatureDiv = body.querySelector('#signatureDiv');
              if (signatureDiv) {
                const firstP = body.querySelector('p:first-child');

                if (firstP) {
                  if (firstP.innerText.trim().length > 0) {
                    firstP.dataset['content'] = 'true';  // hides placeholder
                  } else {
                    delete firstP.dataset['content'];  // shows placeholder
                  }
                }
              }
              //  this.fontSet(this.skip_focus);
              let editableContent = e.getContent({ format: "html" });
              let editableDivContent = this.extractContentFromDiv(editableContent, 'convSuggestionsId')
              if (this.originalContentFromNlpSuggestion != editableDivContent) {
                this.contentEdited = 'Edited'
              } else {
                this.contentEdited = 'Not Edited'
              }
              this.keyupChange.emit("");
              if (event && event.keyCode && event.keyCode === 13 && event.shiftKey === true) {
                this.keyupChangeSymphony.emit("Shift + Enter");
              }
              else if (event && event.keyCode && event.keyCode === 13) {
                this.keyupChangeSymphony.emit("Enter");

              }

            });
          //remove the placeholder (if any) when focus is on
          e.on('focus', () => {

            if (this.isPlaceholderVisible) {
              e.setContent('');
              this.isPlaceholderVisible = false;
            }

            // notify of editor focus
            this.newMessageService.setEditorFocus(true);
            if (!this.isDefaultFontApplied) {
              // this.fontSet(this.skip_focus);
              this.isDefaultFontApplied = true;
            }
          });
          // e.on('blur', () => {
          //   if (e.getContent({format: 'text'}).trim() === '') {
          //     e.setContent(`<span class="mce-placeholder">${this.placeholderText}</span>`);
          //     this.isPlaceholderVisible = true;
          //   }
          // });
          e.ui.registry.addButton('customCloseButton', {
            icon:'close',
            tooltip:'Close',
            onAction: () => {
              const editor = tinymce.get(this.elementId);
              if (editor) {
                // Try to get the toolbar element
                const toolbar = editor.getContainer().querySelector('.tox-editor-header');
                if (toolbar) {
                  toolbar.style.display = 'none';
                }
              }
              this.tabService.setFormatOpen(false);
            }
        });
        e.ui.registry.addGroupToolbarButton('alignment', {
          icon: 'more-drawer',
          tooltip: 'More',
          items: 'strikethrough |alignleft alignright | numlist outdent indent | undo redo | forecolor backcolor |    formatpainter  powerpaste   casechange '
        });
        }
      });
    }, 0);

  }
  handlePaste(event: ClipboardEvent) {
    const storedFile = sessionStorage.getItem('pastedFile');
    if (storedFile) {
      event.preventDefault(); // Prevent default paste behavior
      const fileData = JSON.parse(storedFile);
      this.filePasted.emit(fileData);
    } else {
      console.log('No stored file found in sessionStorage');
    }
  }




  // add skip_focus arg so that user can see the placeholder in new message editor
  fontSet(skip_focus = false) {
    setTimeout(() => {
      /*  tinymce.get(this.elementId).execCommand("fontName", false, this.fontStyle.fontName, {skip_focus: true});
       tinymce.get(this.elementId).execCommand("fontSize", false, this.fontStyle.fontSize, {skip_focus: true});
       */
      let countId = this.newMessageService.getIndex() - 1;
      // for reply screen
      if ($('#my-editor' + countId + '_ifr').contents().find('hr').length > 0) {
        $('#my-editor' + countId + '_ifr').contents().find('hr').first().prevAll().not('.custom-template').css('font-size', this.fontStyle.fontSize);
        $('#my-editor' + countId + '_ifr').contents().find('hr').first().prevAll().not('.custom-template').css('font-family', this.fontStyle.fontName);
        $('#my-editor' + countId + '_ifr').contents().find('hr').first().prevAll().not('.custom-template').css('margin', '0px');

      } else { // new msg scenario
        // apply default font on loading and after adding sign/template/disclaimer
        $('#my-editor' + countId + '_ifr').contents().find('#signatureDiv').first().prevAll().not('.custom-template').css('font-size', this.fontStyle.fontSize);
        $('#my-editor' + countId + '_ifr').contents().find('#signatureDiv').first().prevAll().not('.custom-template').css('font-family', this.fontStyle.fontName);
        $('#my-editor' + countId + '_ifr').contents().find('#signatureDiv').first().prevAll().not('.custom-template').css('margin', '0px');

        $('#my-editor' + countId + '_ifr').contents().find('#signatureReplyMsgDiv').first().prevAll().not('.custom-template').css('font-size', this.fontStyle.fontSize);
        $('#my-editor' + countId + '_ifr').contents().find('#signatureReplyMsgDiv').first().prevAll().not('.custom-template').css('font-family', this.fontStyle.fontName);
        $('#my-editor' + countId + '_ifr').contents().find('#signatureReplyMsgDiv').first().prevAll().not('.custom-template').css('margin', '0px');
        $('#my-editor' + countId + '_ifr').contents().find('#disclaimerReplyMsgDiv').first().next().not('.custom-template').css('font-size', this.fontStyle.fontSize);
        $('#my-editor' + countId + '_ifr').contents().find('#disclaimerReplyMsgDiv').first().next().not('.custom-template').css('font-family', this.fontStyle.fontName);
        $('#my-editor' + countId + '_ifr').contents().find('#disclaimerReplyMsgDiv').first().next().not('.custom-template').css('margin', '0px');
      }
      // when user clicks backspace or select all and delete
      if ($('#my-editor' + countId + '_ifr').contents().find('p').length === 1) {
        $('#my-editor' + countId + '_ifr').contents().find('p').css('font-size', this.fontStyle.fontSize);
        $('#my-editor' + countId + '_ifr').contents().find('p').css('font-family', this.fontStyle.fontName);
        $('#my-editor' + countId + '_ifr').contents().find('p').css('margin', '0px');
      }
      // for template or signature
      if ($('#template_ifr').contents().find('p').length === 1) {
        $('#template_ifr').contents().find('p').css('font-size', this.fontStyle.fontSize);
        $('#template_ifr').contents().find('p').css('font-family', this.fontStyle.fontName);
        $('#template_ifr').contents().find('p').css('margin', '0px');
      }
      if ($('#signature_ifr').contents().find('p').length === 1) {
        $('#signature_ifr').contents().find('p').css('font-size', this.fontStyle.fontSize);
        $('#signature_ifr').contents().find('p').css('font-family', this.fontStyle.fontName);
        $('#signature_ifr').contents().find('p').css('margin', '0px');
      }
      // for email as a chat
      this.applyDefaultFontTOEmailAsaChat();


    }, 0);
  }
  // Editor: Latest selected font-family and font-size should be applied automatically while new-message and reply.
  setSelectedfont(skip_focus = false) {
    const font = this.getSelectedFont();
    tinymce.get(this.elementId).execCommand("fontName", false, font.name, { skip_focus: true });
    tinymce.get(this.elementId).execCommand("fontSize", false, font.size, { skip_focus: true });
  }
  // Catch the exception, so that it doesn't break the flow. User is not to switch the inquiry
  getSelectedFont() {
    let font = { name: "", size: "" };
    try {
      if (tinymce.get(this.elementId)) {
        font.name = tinymce.get(this.elementId).queryCommandValue("FontName") === "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif"
          ? this.fontStyle.fontName : tinymce.get(this.elementId).queryCommandValue("FontName");
        font.size = tinymce.get(this.elementId).queryCommandValue("FontSize") === "" ? this.fontStyle.fontSize : tinymce.get(this.elementId).queryCommandValue("FontSize");
      }
    } catch (e) {
      console.log("Exception while getting the font details : ", e)
    }
    return font;
  }

  enableFlag() {
    this.LoadFlag.next(true);
    this.originalContentFromNlpSuggestion = this.extractContentFromDiv(tinymce.get(this.elementId).getContent({ format: "html" }), 'convSuggestionsId')
    if (tinymce.editors && tinymce.editors.length) {
      const lastIndex = tinymce.editors.length - 1;
      tinymce.editors[lastIndex].shortcuts.add('alt+s', 'Send', () => {
        if (this.messageInstance) {
          this.sendEvent.emit({ messageInstance: this.messageInstance, action: 'Send' });
        }
      });
      tinymce.editors[lastIndex].on('dragover', (e) => {
        if (e && e.target) {
          e.target.focus();
        }
      });
      tinymce.editors[lastIndex].on('drop', (e) => {
        const data = e.dataTransfer.getData('text');
        if (data && data.startsWith(QmaConstant.QMA_DND_HEADER)) {
          this.sendEvent.emit({ messageInstance: this.messageInstance, data: data, action: 'drop' });
          // e.preventDefault();
          e.stopPropagation();
        }
      });
    }
  }
  // add placeholder
  getPlaceholder() {
    // [C170665-1284] - Disable the placeholder message
    return "";
  }

  getData() {
    if (!this.isNull(tinymce.get(this.elementId))) {
      return (tinymce.get(this.elementId).getContent());
    }
  }
  setData(content: String) {

    // if (!content || content.trim() === '') {
    //   if (tinymce.get(this.elementId)) {
    //     tinymce.get(this.elementId).setContent(`<span class="mce-placeholder">${this.placeholderText}</span>`);
    //     this.isPlaceholderVisible = true;
    //   }
    //   return;
    // }

    // handling content upon its loading to T editor (initial loading case which is not covered by paste plugin)
    if (content) {
      // return the second group in regex if matched
      content = content.replace(/(<!\[if !supportLists\]>)([^!]*)(<!\[endif\]>)/g, (match, p1, p2, p3, offset, string) => {
        return p2;
      });
      // additional filtering of MS HTML metatags
      content = content.replace(/(<!\[if !vml\]>)([^!]*)(<!\[endif\]>)/g, (match, p1, p2, p3, offset, string) => {
        return p2;
      });
      // Auto generated email with comments corrupting html contents
      // already removing comments in maildetailview replaceWildCharacters
      // content = content.replace(/(<!\[endif\]-->)/g, '');

    }
    if (!this.LoadFlag.getValue()) {

      //subscribing for flag to look for Tiny is  loaded or not--

      this.LoadFlag.subscribe(val => {


        if (tinymce.get(this.elementId) != null) {

          if (val) {
            if (content) {
              tinymce.get(this.elementId).setContent(content);
              this.isPlaceholderVisible = false;
            } else {
              console.log('exp-tiny, content empty', content);
            }

          } else {
            console.log("erroe loading in data");
          }
        }
      });
    }
    else {
      tinymce.get(this.elementId).setContent(content);
      this.isPlaceholderVisible = false;
    }
  }

  clearEditorForTaskize() {
    tinymce.get(this.elementId).setContent('');
  }

  // Format Method
  appnedData(content: String, elemID) {
    let cnt = tinymce.get(this.elementId).getContent();
    let arr: string[] = cnt.split("\n")
    let num: number = arr.length;
    let i: number;
    let editorContent: string = "";
    let indexSignNewMsg: number = 0;
    let disclaimerNewMsg: number = 0;
    let indexSignReplyMsg: number = 0;
    let indexDisclaimReplyMsg: number = 0;
    for (i = 0; i < num; i++) {
      var str = arr[i];
      if (str.indexOf('signatureDiv') != -1) { indexSignNewMsg = i; }
      if (str.indexOf('disclaimerDiv') != -1) { disclaimerNewMsg = i; }
      if (str.indexOf('signatureReplyMsgDiv') != -1) { indexSignReplyMsg = i; }
      if (str.indexOf('disclaimerReplyMsgDiv') != -1) { indexDisclaimReplyMsg = i; break; }
    }
    if ((indexSignReplyMsg != 0) && (indexDisclaimReplyMsg != 0)) {
      let rm = arr.splice(indexSignReplyMsg + 1, (indexDisclaimReplyMsg - indexSignReplyMsg) - 1, "<p>" + content.toString() + "</p><br>");
    } else if (indexSignReplyMsg != 0 || indexDisclaimReplyMsg != 0) {
      let rm = arr.splice(indexDisclaimReplyMsg, 0, "<div id='signatureReplyMsgDiv' contenteditable = 'false' style='cursor: text;outline: none;'></div><p>" + content.toString() + "</p><br>");
    }
    else {
      let rm = arr.splice(indexSignNewMsg + 1, (disclaimerNewMsg - indexSignNewMsg) - 1, "<p>" + content.toString() + "</p><br>");
    }
    arr.forEach(x => {
      editorContent += x;
    });
    tinymce.get(this.elementId).setContent(editorContent);
    this.fontSet(true);
  }
ngOnInit(){
  if (this.horizontalStyle) {
    this.horizontalView = true;
  }
  this.viewClickedSubscription = this.tabService
    .getClickedIcon()
    .subscribe((clickedIcon) => {
      if (!this.horizontalStyle) {
        if (clickedIcon && typeof clickedIcon === 'string') {
          if (clickedIcon.toLowerCase() === 'horizontal') {
            this.horizontalView = true;
          } else {
            this.horizontalView = false;
          }
        }
      }
    });
}
  ngOnDestroy() {
    if (this.originalXhrOpen) {
      // QMA-1951: Restoring original XHR functions
      XMLHttpRequest.prototype.open = this.originalXhrOpen;
      XMLHttpRequest.prototype.send = this.originalXhrSend;
    }
    if (tinymce.get(this.elementId)) {
      tinymce.get(this.elementId).execCommand('mceRemoveControl', true, '#' + this.elementId);
    }
    tinymce.remove('#' + this.elementId);
    this.LoadFlag.unsubscribe();
    this.viewClickedSubscription?.unsubscribe();
    this.tabService.setFormatOpen(true);
  }

  getId() {
    return this.elementId;
  }

  // Null value check function
  isNull(input) {
    if (input === "" || input === undefined || input == null) {
      return true;
    }
    return false;
  }
  applyDefaultFontTOEmailAsaChat() {
    if ($("#" + this.elementId + '_ifr').contents().find('p').length === 1) {
      $("#" + this.elementId + '_ifr').contents().find('p').css('font-size', this.fontStyle.fontSize);
      $("#" + this.elementId + '_ifr').contents().find('p').css('font-family', this.fontStyle.fontName);
      $("#" + this.elementId + '_ifr').contents().find('p').css('margin', '0px');
    }

  }

  reInitialiseTinyMCE() {
    this.forPdfViewerReInitialise = true;
    this.contentBeforeEditorReload = this.getData();
    tinymce.remove('#' + this.elementId);
    this.loadEditor = false;
    setTimeout(() => {
      this.loadEditor = true;
      this.ngAfterViewInit();
    }, 2000);
  }

  setNlpEditedFlag(data) {
    this.contentEdited = data
  }

  extractContentFromDiv(nlpContent, divId) {
    let div = document.createElement('div');
    div.innerHTML = nlpContent;
    let divData = div.querySelector('#' + divId)
    return divData ? divData.textContent : null;
  }
}